import React from "react";

export const PLAN_LABELS = {
  original_body_dropped: "raw source bodies to drop",
  tombstones_stripped: "purged tombstones to strip",
  stuck_rewriting_deleted: "stuck 'rewriting' articles to delete",
  stale_drafts_deleted: "never-published drafts older than 14d to delete",
  sites_moved_to_14d_window: "sites to move to the 14/14-day window",
};

const sum = (obj) => Object.values(obj || {}).reduce((a, b) => a + b, 0);

export function planTotal(plan) {
  if (!plan) return 0;
  return Object.keys(PLAN_LABELS).reduce((a, k) => a + (plan[k] || 0), 0) + sum(plan.logs_deleted);
}

export function PlanList({ plan, done }) {
  if (!plan) return null;
  const logs = plan.logs_deleted || {};
  const rows = [
    ...Object.entries(PLAN_LABELS).map(([k, label]) => [k, plan[k], label]),
    ["logs", sum(logs), `log docs to delete (${Object.entries(logs).map(([c, n]) => `${c} ${n}`).join(", ")})`],
  ];
  return (
    <ul data-testid={done ? "storage-trim-result" : "storage-trim-plan"} className="text-xs mono space-y-1">
      {rows.map(([k, n, label]) => (
        <li key={k} className={n ? "text-amber-300" : "text-zinc-600"}>
          <span className="inline-block w-14 text-right mr-2 tabular-nums">{n ?? 0}</span>{done ? label.replace(/ to /, " — ") : label}
        </li>
      ))}
    </ul>
  );
}

export function CollectionsTable({ data }) {
  return (
    <div>
      <div className="label-tiny mb-2">Collections (on disk)</div>
      <table data-testid="storage-collections" className="w-full text-xs mono">
        <tbody>
          {data.collections.slice(0, 10).map((c) => (
            <tr key={c.name} className="border-t border-zinc-900">
              <td className="py-1 text-zinc-300 truncate max-w-[140px]">{c.name}</td>
              <td className="py-1 text-right text-zinc-500 tabular-nums">{c.count.toLocaleString()}</td>
              <td className="py-1 text-right text-zinc-100 tabular-nums">{c.storage_mb} MB</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="text-[11px] text-zinc-500 mono mt-2">db data {data.db.data_mb} MB · storage {data.db.storage_mb} MB · indexes {data.db.index_mb} MB</div>
    </div>
  );
}

export function ArticlesTable({ rows }) {
  return (
    <div>
      <div className="label-tiny mb-2">Articles by status</div>
      <table data-testid="storage-articles" className="w-full text-xs mono">
        <thead><tr className="text-zinc-600 text-[10px] uppercase"><th className="text-left">status</th><th className="text-right">docs</th><th className="text-right">body</th><th className="text-right">raw src</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.status} className="border-t border-zinc-900">
              <td className="py-1 text-zinc-300">{r.status}</td>
              <td className="py-1 text-right text-zinc-500 tabular-nums">{r.count.toLocaleString()}</td>
              <td className="py-1 text-right text-zinc-100 tabular-nums">{r.body_mb} MB</td>
              <td className={`py-1 text-right tabular-nums ${r.original_mb > 0 && !["pending", "rewriting"].includes(r.status) ? "text-amber-300" : "text-zinc-500"}`}>{r.original_mb} MB</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
